export default "__VITE_ASSET__1PJXgAo2__"